import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from "@angular/forms";
import {CustomValidationService} from "../services/custom-validation.service";

@Directive({
  selector: '[not-null]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NotNullDirective, multi: true }]
})
export class NotNullDirective {

  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.notNullValidator()(control);
  }

}
